
export default function Hero() {
  const scrollToContact = () => {
    const element = document.getElementById('contacto');
    if (element) {
      element.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="inicio" className="relative min-h-screen flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/5b774e6570e71ca7460dbc498b6b9ff1.jpg"
          alt="Talleres Lujambio"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-6 text-center w-full">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-bold text-white mb-6 leading-tight">
          Talleres Lujambio
        </h1>
        <p className="text-xl md:text-2xl text-white/95 mb-8 max-w-3xl mx-auto leading-relaxed">
          Referencia en el sector industrial con casi medio siglo de historia
        </p>
        <p className="text-lg md:text-xl text-white/90 mb-10 max-w-2xl mx-auto">
          Mecanizado, equilibrado industrial, enderezado y construcción mecánica de precisión
        </p>
        <button
          onClick={scrollToContact}
          className="bg-teal-600 text-white px-8 py-4 rounded-full text-lg font-semibold hover:bg-teal-700 transition-all duration-300 shadow-lg hover:shadow-xl whitespace-nowrap"
        >
          Contactar
        </button>
      </div>
    </section>
  );
}
